
import { Component, Vue, Prop } from "vue-property-decorator";
import { formatUpyunUrl } from "@/utils";
@Component({
  components: {}
})
export default class GrowthModule extends Vue {
  formatUpyunUrl = formatUpyunUrl;
  pic1 = "/img/a86288d85c99f861824006032bdd5eb9.png";
  pic2 = "/img/45381832ad4779787a93794409a8c593.png";
  pic3 = "/img/8cda7ad4eebb3b9024928d70bd381c65.png";
  pic4 = "/img/94eb9fc701487a5a7ed64106a94b1a13.png";
  pic5 = "/img/8a1d3922a25beb08d1469e13855efdf9.png";
}
